// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import DefaultChartPropsDefinedSchema from './Izenda.DefaultChartPropsDefinedSchema';
import DefaultChartPropsMappingProps from './Izenda.DefaultChartPropsMappingProps';
import DefaultChartPropsMappingSource from './Izenda.DefaultChartPropsMappingSource';
import DefaultChartPropsWidget from './Izenda.DefaultChartPropsWidget';
import DefaultChartPropsOnChangeValue from './Izenda.DefaultChartPropsOnChangeValue';
import DefaultChartOptionsBuilder from './Izenda.DefaultChartOptionsBuilder';
import ReportPartChartContent from 'logic/models/Izenda.ReportPartChartContent';
import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import { COMMON_OPTIONS, THRESHOLDS_LINE, AXIS_OPTIONS } from './Izenda.DefaultChartOptionsMappings';
import { constant } from 'lodash/fp';
import { Highcharts } from 'share/components/charting/highcharts/Izenda.HighchartsVizNames';
import cfgFactories from 'share/factories/Izenda.ReportPartConfigurationFactories';

/** Default chart configuration */
cfgFactories.setConfiguration(REPORT_PART_TYPE.Chart, {
  /**
   * Visualization engine name
   */
  visualEngine: Highcharts,

  /**
   * Label of visualization, normally showing in chart type dropdown
   */
  visualLabel: null,

  /**
   * A CSS class to show preview image of the visualization, normally showing when hovering a chart dropdown item
   */
  visualPreviewCSS: null,

  /**
   * Type of visualization, e.g. chart type in Highcharts
   */
  visualType: null,

  /**
   * The builder class to build chart visualization options
   */
  optionsBuilder: DefaultChartOptionsBuilder,

  /**
   * Report part content model class
   */
  model: ReportPartChartContent,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [
    constant({
      chart_title: true
    })
  ],

  /**
   * The object contains the property editor widget component
   */
  propertyWidgets: DefaultChartPropsWidget,

  /**
   * The object contains defined schema of property editor GUI
   */
  propertySchema: DefaultChartPropsDefinedSchema,

  /**
   * The function to create the mapping properties
   */
  propertyMappingProps: DefaultChartPropsMappingProps,

  /**
   * The function to create the mapping source
   */
  propertyMappingSource: DefaultChartPropsMappingSource,

  /**
   * The function to create an value changed handler
   */
  propertyValueChange: DefaultChartPropsOnChangeValue,

  optionsMapping: {
    /**
     * The object containts common options mapping
     */
    commonOptions: COMMON_OPTIONS,

    /**
     * The object contains options by type mapping
     */
    optionsByType: {},

    /**
     * The object contains the threshold options mapping
     */
    thresholdOptions: THRESHOLDS_LINE,

    /**
     * The object contains the axis options mapping
     */
    axisOptions: AXIS_OPTIONS
  }
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.DefaultChartConfiguration.js